import { render, staticRenderFns } from "./OrderFunctionStatus.vue?vue&type=template&id=08ef48de&scoped=true"
import script from "./OrderFunctionStatus.vue?vue&type=script&lang=js"
export * from "./OrderFunctionStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderFunctionStatus.vue?vue&type=style&index=0&id=08ef48de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef48de",
  null
  
)

export default component.exports